/**
 * Agent Observability Constants
 *
 * Event names for agent observability. Error categorization is derived in the service
 * and sent as errorCategory on each failure event for New Relic.
 */

/**
 * Event tracked when agent search fails
 */
export const AGENT_SEARCH_FAILURE = 'agent_search_failure' as const;

/**
 * Event tracked when agent profile view fails
 */
export const AGENT_PROFILE_VIEW_FAILURE = 'agent_profile_view_failure' as const;

/**
 * Event tracked when reCAPTCHA token generation fails or script fails to load
 */
export const AGENT_RECAPTCHA_TOKEN_FAILURE = 'agent_recaptcha_token_failure' as const;
